import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const Sparkle = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="M12 2.5l1.9 5.1a3 3 0 0 0 1.75 1.75L20.75 11l-5.1 1.9a3 3 0 0 0-1.75 1.75L12 19.75l-1.9-5.1a3 3 0 0 0-1.75-1.75L3.25 11l5.1-1.9a3 3 0 0 0 1.75-1.75L12 2.5z"
    />
    <path d="M19 3l.7 1.9L21.5 5.6l-1.8.7L19 8.2l-.7-1.9-1.8-.7 1.8-.7L19 3z" />
  </SvgIcon>
);
